var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeTutorFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.538 20.2178C13.6542 20.2119 15.7958 19.4775 17.366 17.9404C15.9969 17.3623 14.571 16.9463 13.3163 16.1308V15.2842V14.4902C14.7313 13.2099 14.8612 12.9717 15.1903 11.087C15.3172 10.9883 15.4471 10.8868 15.5614 10.7979C15.619 10.1172 15.6737 9.47465 15.7284 8.83013C15.5751 8.72759 15.453 8.64654 15.3426 8.57233C15.4764 5.74508 13.3749 4.52458 11.5379 4.49808H11.532H11.5262C9.68826 4.52444 7.58666 5.74515 7.72141 8.57233C7.61106 8.64655 7.48997 8.7276 7.33566 8.83013C7.39035 9.47465 7.44504 10.1172 7.50265 10.7979C7.61691 10.8868 7.74679 10.9883 7.87375 11.087C8.20285 12.9717 8.33273 13.209 9.74778 14.4902V15.2842V16.1308C8.4929 16.9463 7.06703 17.3623 5.69803 17.9404C7.26833 19.4775 9.41103 20.2129 11.526 20.2178H11.5319C11.5338 20.2187 11.5358 20.2187 11.5377 20.2178H11.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4005 10.5995C21.7784 3.99401 15.7197 -0.237489 9.58124 0.826011C4.81374 1.65121 1.45325 5.75276 1.0705 8.81051C1.42987 9.23044 1.73065 9.58199 2.0578 9.96384C3.19257 4.09184 8.71304 1.32809 13.0968 2.12009C17.6515 2.94334 20.674 6.74909 20.961 10.5996H20.0636L21.6818 12.2226L23.2999 10.5996L22.4005 10.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599608 12.4005C1.22168 19.007 7.28036 23.2385 13.4189 22.175C18.1854 21.3488 21.5469 17.2482 21.9286 14.1905C21.5692 13.7706 21.2685 13.419 20.9413 13.0372C19.8065 18.9082 14.2861 21.6719 9.90231 20.8799C5.34756 20.0567 2.32506 16.2499 2.03806 12.4004H2.93551L1.31733 10.7774L-0.300842 12.4004L0.599608 12.4005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeTutorFilled);
export default __webpack_public_path__ + "static/media/change_tutor_filled.996953cf3ea5b59903994c23f739e2af.svg";
export { ForwardRef as ReactComponent };